import { render, staticRenderFns } from "./DeliveryMethods.vue?vue&type=template&id=44968f9e&scoped=true&"
import script from "./DeliveryMethods.vue?vue&type=script&lang=js&"
export * from "./DeliveryMethods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44968f9e",
  null
  
)

export default component.exports